import { useEffect } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  .shop-page { font-family:'DM Sans',sans-serif; background:#f8f6f0; min-height:100vh; color:#1a1a2e; }

  .shop-hero {
    background: linear-gradient(135deg, #0d2137 0%, #1a3a5c 50%, #0f5c3a 100%);
    padding: 80px 40px 60px; position: relative; overflow: hidden;
  }
  .shop-hero::before {
    content:''; position:absolute; top:-30%; left:-5%; width:350px; height:350px;
    background:radial-gradient(circle,rgba(46,213,115,0.12) 0%,transparent 70%); border-radius:50%;
  }
  .shop-hero::after {
    content:''; position:absolute; bottom:0; left:0; right:0; height:4px;
    background:linear-gradient(90deg,#2ed573,#7bed9f,#2ed573);
  }
  .brand-badge { display:inline-flex; align-items:center; gap:10px; background:rgba(46,213,115,0.12); border:1px solid rgba(46,213,115,0.3); padding:8px 20px; border-radius:50px; margin-bottom:24px; }
  .brand-dot { width:8px; height:8px; background:#2ed573; border-radius:50%; animation:pulse 2s infinite; }
  @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(0.8)} }
  .brand-name { color:#2ed573; font-size:13px; font-weight:600; letter-spacing:2px; text-transform:uppercase; }
  .shop-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(36px,5vw,56px); font-weight:800; color:#fff; margin:0 0 16px; line-height:1.1; }
  .shop-hero p { color:rgba(255,255,255,0.6); font-size:15px; font-weight:300; max-width:500px; }
  .policy-meta { display:flex; gap:16px; margin-top:32px; flex-wrap:wrap; }
  .meta-chip { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.12); padding:6px 16px; border-radius:6px; color:rgba(255,255,255,0.7); font-size:12px; font-weight:500; }

  .policy-body { max-width:860px; margin:0 auto; padding:60px 40px; }

  .payment-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:16px; margin-bottom:48px; }
  .payment-card { background:#fff; border:1px solid #e8e4da; border-radius:12px; padding:24px 20px; text-align:center; box-shadow:0 2px 12px rgba(0,0,0,0.04); transition:transform 0.2s,box-shadow 0.2s; }
  .payment-card:hover { transform:translateY(-3px); box-shadow:0 8px 24px rgba(0,0,0,0.08); }
  .payment-icon { font-size:32px; margin-bottom:10px; }
  .payment-card h4 { font-size:14px; font-weight:600; margin:0 0 4px; color:#1a1a2e; }
  .payment-card p { font-size:12px; color:#888; margin:0; }

  .section-card { background:#fff; border:1px solid #e8e4da; border-radius:16px; overflow:hidden; margin-bottom:24px; box-shadow:0 2px 12px rgba(0,0,0,0.04); }
  .section-card-header { background:linear-gradient(135deg,#0d2137,#1a3a5c); padding:20px 28px; display:flex; align-items:center; gap:14px; }
  .section-icon { font-size:22px; }
  .section-card-header h2 { font-family:'Playfair Display',serif; font-size:20px; font-weight:700; color:#fff; margin:0; }
  .section-card-body { padding:28px; font-size:15px; line-height:1.8; color:#3a3a50; }
  .section-card-body p { margin:0 0 14px; } .section-card-body p:last-child { margin:0; }

  .info-list { list-style:none; padding:0; margin:12px 0; }
  .info-list li { display:flex; align-items:flex-start; gap:10px; padding:10px 0; border-bottom:1px solid #f0ece4; font-size:14px; }
  .info-list li:last-child { border-bottom:none; }
  .check-icon { color:#2ed573; font-weight:bold; flex-shrink:0; margin-top:2px; }

  .highlight-green { background:linear-gradient(135deg,#f0fff8,#e8fff3); border-left:4px solid #2ed573; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }
  .highlight-yellow { background:linear-gradient(135deg,#fffbf0,#fff8e6); border-left:4px solid #ffa502; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }

  .price-table { width:100%; border-collapse:collapse; margin:16px 0; font-size:14px; }
  .price-table th { background:#f0ece4; padding:12px 16px; text-align:left; font-weight:600; color:#1a1a2e; font-size:13px; text-transform:uppercase; letter-spacing:0.5px; }
  .price-table td { padding:12px 16px; border-bottom:1px solid #f0ece4; color:#3a3a50; }
  .price-table tr:last-child td { border-bottom:none; }
  .price-table tr:hover td { background:#f8f6f0; }

  .contact-card { background:linear-gradient(135deg,#0d2137,#0f5c3a); border-radius:16px; padding:36px; text-align:center; margin-top:48px; color:white; }
  .contact-card h3 { font-family:'Playfair Display',serif; font-size:24px; margin:0 0 12px; color:#2ed573; }
  .contact-card p { color:rgba(255,255,255,0.7); margin:0 0 24px; font-size:14px; }
  .contact-links { display:flex; justify-content:center; gap:16px; flex-wrap:wrap; }
  .contact-link { background:rgba(46,213,115,0.15); border:1px solid rgba(46,213,115,0.4); color:#2ed573; padding:10px 24px; border-radius:8px; text-decoration:none; font-size:14px; font-weight:500; transition:all 0.2s; }
  .contact-link:hover { background:#2ed573; color:#0d2137; }

  @media(max-width:600px) {
    .shop-hero{padding:60px 20px 40px} .policy-body{padding:40px 20px} .section-card-body{padding:20px}
  }
`;

const paymentMethods = [
  { icon: "💳", name: "Credit / Debit Card", desc: "Visa, Mastercard, RuPay" },
  { icon: "📱", name: "UPI", desc: "GPay, PhonePe, Paytm" },
  { icon: "🏦", name: "Net Banking", desc: "All major banks" },
  { icon: "💰", name: "Wallets", desc: "Paytm, Mobikwik" },
  { icon: "🔄", name: "EMI", desc: "0% EMI available" },
];

export default function ShoppingPolicy() {
  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  return (
    <div className="shop-page">
      <div className="shop-hero">
        <div className="brand-badge"><div className="brand-dot" /><span className="brand-name">ITI Expert Guruji</span></div>
        <h1>Shopping & Payment Policy</h1>
        <p>Secure, simple, and transparent — shop on our platform with complete confidence.</p>
        <div className="policy-meta">
          <span className="meta-chip">📅 Effective: January 1, 2025</span>
          <span className="meta-chip">🔒 100% Secure Payments</span>
          <span className="meta-chip">🇮🇳 India Based</span>
        </div>
      </div>

      <div className="policy-body">
        <div className="payment-grid">
          {paymentMethods.map((m) => (
            <div key={m.name} className="payment-card">
              <div className="payment-icon">{m.icon}</div>
              <h4>{m.name}</h4>
              <p>{m.desc}</p>
            </div>
          ))}
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">📚</span><h2>Course Purchase Process</h2></div>
          <div className="section-card-body">
            <p>Purchasing a course on ITI Expert Guruji is quick and easy:</p>
            <ul className="info-list">
              <li><span className="check-icon">✓</span> Log in to your account and select the desired course</li>
              <li><span className="check-icon">✓</span> Click "Enroll Now" and choose your preferred payment method</li>
              <li><span className="check-icon">✓</span> Upon successful payment, course access is granted immediately</li>
              <li><span className="check-icon">✓</span> A confirmation email with invoice will be sent to your registered email</li>
              <li><span className="check-icon">✓</span> Access is available on both mobile app and website</li>
            </ul>
            <div className="highlight-green"><strong>✅ Instant Access:</strong> Course becomes available within 5 minutes of payment confirmation.</div>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">💰</span><h2>Pricing & GST Policy</h2></div>
          <div className="section-card-body">
            <p>All prices on ITI Expert Guruji are transparent and clearly displayed:</p>
            <table className="price-table">
              <thead>
                <tr><th>Course Type</th><th>Price Range</th><th>GST</th></tr>
              </thead>
              <tbody>
                <tr><td>Individual Subjects</td><td>₹199 – ₹999</td><td>18%</td></tr>
                <tr><td>Full Year Packages</td><td>₹1,999 – ₹7,999</td><td>18%</td></tr>
                <tr><td>Mock Test Series</td><td>₹299 – ₹1,499</td><td>18%</td></tr>
                <tr><td>Live Classes</td><td>₹499 – ₹2,999/month</td><td>18%</td></tr>
              </tbody>
            </table>
            <div className="highlight-yellow"><strong>⚠️ Note:</strong> Displayed prices are exclusive of GST. GST is applied separately at checkout. A full breakdown is visible in your invoice.</div>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">🔐</span><h2>Payment Security</h2></div>
          <div className="section-card-body">
            <p>Your money and data are 100% safe with us:</p>
            <ul className="info-list">
              <li><span className="check-icon">✓</span> Razorpay-powered 256-bit SSL encrypted payments</li>
              <li><span className="check-icon">✓</span> PCI-DSS Level 1 compliant payment gateway</li>
              <li><span className="check-icon">✓</span> Card details are never stored on ITI Expert Guruji servers</li>
              <li><span className="check-icon">✓</span> Mandatory 3D Secure authentication (OTP) for all transactions</li>
              <li><span className="check-icon">✓</span> Real-time fraud detection and suspicious activity monitoring</li>
            </ul>
            <div className="highlight-green"><strong>✅ RBI Compliant:</strong> All transactions are processed in accordance with Reserve Bank of India guidelines.</div>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">🏷️</span><h2>Offers & Coupon Codes</h2></div>
          <div className="section-card-body">
            <ul className="info-list">
              <li><span className="check-icon">✓</span> Coupon codes must be entered on the checkout page before payment</li>
              <li><span className="check-icon">✓</span> Only one coupon code can be applied per order</li>
              <li><span className="check-icon">✓</span> Coupon codes are non-transferable and for personal use only</li>
              <li><span className="check-icon">✓</span> Expired coupons cannot be applied after payment is completed</li>
              <li><span className="check-icon">✓</span> For group or school discounts, contact us via the enquiry form</li>
            </ul>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">🔄</span><h2>Subscriptions & Auto-Renewal</h2></div>
          <div className="section-card-body">
            <p>For monthly or yearly subscription plans:</p>
            <ul className="info-list">
              <li><span className="check-icon">✓</span> Auto-renewal is enabled by default — it can be turned off in Account Settings</li>
              <li><span className="check-icon">✓</span> An email reminder is sent 7 days before the renewal date</li>
              <li><span className="check-icon">✓</span> To cancel renewal, notify us at least 24 hours before the due date</li>
              <li><span className="check-icon">✓</span> After cancellation, access continues until the end of the current billing period</li>
            </ul>
            <div className="highlight-yellow"><strong>⚠️ Important:</strong> Annual plans are non-refundable after 14 days from the date of purchase.</div>
          </div>
        </div>

        <div className="contact-card">
          <h3>Payment Issue?</h3>
          <p>Payment failed or charged but no course access? We resolve it within 24 hours.</p>
          <div className="contact-links">
            <a href="mailto:msmahajan79@gmail.com" className="contact-link">✉ msmahajan79@gmail.com</a>
            <a href="tel:+91 9421989575" className="contact-link">📞 +91  9421989575</a>
          </div>
        </div>
      </div>
    </div>
  );
}
